import { type ReactElement } from "react"
import { flushSync } from "react-dom"
import { createRoot } from "react-dom/client"

/**
 * A Phosphor icon as a detached DOM node, for an ag-grid menu item (`icon` takes an Element or an
 * HTML string, not JSX).
 *
 * A fresh node per call, deliberately: a DOM element can only be in one place, and the same glyph
 * appears on more than one row of a single menu ("Expand row" and "Expand all"), where a shared
 * node would leave the first row's slot empty. The menu is built once per right-click, so this
 * renders a handful of icons on an explicit user action.
 */
export const menuIcon = (icon: ReactElement): HTMLElement => {
  const host = document.createElement("span")
  flushSync(() => createRoot(host).render(icon))
  return host
}
